import React from 'react';
import { History } from 'history';
import { Input, InputFile, InputNumber, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './report-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class ReportCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private historyState: any = this.props.history.location.state;

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadParent = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'parent': data?.id, 'parentCaption': data?.name || ''  }  });
    }
    
    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    ;
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        var  option = this.state.datarow.option;
        if (fieldName==='type' && !this.state.datarow.parent && value) option = Model.option[value];        

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, option: option,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..      
            <>     
            {this.historyState?.id > 0 &&
            <BaseView history={this.props.history} caption=''
                model={Model} onLoad={this.onLoadParent}/>
            }        
            <BaseCreate history={this.props.history} caption={this.state.datarow.parent && 'Create ' +Model.caption+ ' Section'}
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onError={this.onError} disableAutoBack>              
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                {this.historyState?.id > 0 &&
                <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                }
                <Input name='title' label='Title' value={this.state.datarow.title} error={this.state.errors?.title} onChange={this.onChange} />
                <InputMultiline name='content' label='Content' value={this.state.datarow.content} error={this.state.errors?.content} onChange={this.onChange} />
                <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={this.state.datarow.parent? Model.optionTypeSection : Model.optionType} error={this.state.errors?.type} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                <Input name='imagetitle' label='Image Title' value={this.state.datarow.imagetitle} error={this.state.errors?.imagetitle} onChange={this.onChange} />

            </BaseCreate>
            </>
        );
    }     
     
}